import { PropsWithChildren } from 'react';
import { Expandable } from '@fabric-ds/react';

type FilterGroupProps = {
    title: string;
    expanded?: boolean;
    testId?: string;
};

export const FilterGroup = ({ title, children, expanded = true, ...otherProps }: PropsWithChildren<FilterGroupProps>) => (
    <Expandable box animated expanded={expanded} className="rounded-0 border-t" title={title} {...otherProps}>
        {children}
    </Expandable>
);
